import React, { type FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useSearch } from '@/Module/DefaultLayout/Hook';
import { IconSearch } from '@/Module/Icon';
import SearchBox from './SearchBox';
const Search: FC = () => {
  const {
    searchIsOpen,
    onToggle
  } = useSearch();
  return <div className="relative z-[60]" data-sentry-component="Search" data-sentry-source-file="Search.tsx">
      <Button color="transparent" radius="circle" type="button" iconButton onClick={onToggle} ariaLabel="جستجو" data-sentry-element="Button" data-sentry-source-file="Search.tsx">
        <IconSearch data-sentry-element="IconSearch" data-sentry-source-file="Search.tsx" />
      </Button>

      <SearchBox isOpen={searchIsOpen} onToggle={onToggle} data-sentry-element="SearchBox" data-sentry-source-file="Search.tsx" />
    </div>;
};
export default React.memo(Search);